<template>
  <div>
    <div class="grid queue-item" :class="innerClasses" @click.prevent="handleClick($event, item.id)">
      <slot></slot>
    </div>
    <div class="wo-divider--dots" v-if="divider"><span class="glyphicon glyphicon-option-horizontal" aria-hidden="true"></span></div>
  </div>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'QueueItem',
    props: {
      item: {
        type: Object,
        default() { return {} },
      },
      divider: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Array,
        default: function () { return [] }
      },
      linked: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        firstItemClass: 'queue-item__detail--first-item'
      }
    },
    computed: {
      innerClasses() {
        const initialClasses = {
          'queue-item--no-shadow': this.linked,
        };
        return lodash.reduce(this.classes, (classes, class_str) => {
          classes[class_str] = true;
          return classes;
        }, initialClasses);
      },
    },
    methods: {
      handleClick(event, id) {
        this.$emit('handle-click', { event: event, id: id });
      }
    },
    watch: {},
  }
</script>

<style lang="scss" scoped>
  .queue-item {
    background:$white;
    border: 1px solid $dark-silver;
    border-radius:em(3px);
    transition:.2s;
    display: flex;
    padding:em(1px);
    margin-top: em(10px);
    &:hover {
      border:1px solid $curiouser-blue;
      box-shadow: 0 em(1px) em(3px) 0 rgba(17, 118, 187, 0.35);
      cursor:pointer;
      transition:.2s;
      .queue-item--hoverable {
        background: $selago;
      }
    }
    @include m(no-hover) {
      &:hover {
        border:1px solid $alto;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
        cursor:default;
        transition:.2s;
      }
    }
    @include m(no-shadow) {
      box-shadow:none;
      &:hover {
        box-shadow:none;
      }
    }
    @include e(detail) {
      border-left:1px solid $quicksilver;
      padding: 0.625em;
      &:first-of-type {
        border-left:none;
      }
      @include m(flex-container) {
        display:flex;
        flex-direction:row;
        justify-content:space-around;
      }
    }
  }
</style>
